module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Outer', [_c('div', {
    staticClass: "row lobby-article-list"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "articles-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pager.loading),
      expression: "!pager.loading"
    }],
    staticClass: "text-center mb20"
  }, [_c('span', {
    staticClass: "f20"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _vm._l((_vm.pager.articles), function(article) {
    return _c('div', {
      staticClass: "mb10"
    }, [_c('a', {
      staticClass: "nb-a",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return article.click()
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(article.title) + "\n\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("simpleDate")(article.releaseTime)) + "\n\t\t")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('NbPager', {
    attrs: {
      "pager": _vm.pager,
      "callback": _vm.refresh
    }
  })], 1)], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-049de436"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/article/List.vue
// module id = 945
// module chunks = 1